<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    persistent
  >
    <v-card :color="isStartShare ? 'blue lighten-4' : 'primary'" class="card-dialog px-2">
      <v-card-title class="headline font-weight-medium">
        Chia sẻ lộ trình
        </v-card-title>
      <v-btn icon dark @click="close" class="btn-close black--text">
        <v-icon>close</v-icon>
      </v-btn>

      <v-card-text class="pt-0 subheading">
        Gửi cho bạn bè vị trí xe của bạn trong các chuyến đi chơi, đi phượt,... giúp cho các buổi hẹn hò trở nên ý nghĩa hơn!
      </v-card-text>

      <v-card class="mx-3 pa-4 box-white text-xs-center">
        <h3 class="headline font-weight-bold mb-3">{{ selectedVehicle.plate }}</h3>
        <v-divider/>
        <h4 class="my-3 font-weight-medium subheading" v-if="isStartShare">Thời gian chia sẻ còn lại</h4>
        <h4 class="my-3 font-weight-medium subheading" v-else>Thời gian chia sẻ</h4>
        <p class="font-weight-bold display-1">{{time}}</p> 
        <div>
          <datetime
            v-model="fromDate"
            input-id="fromDate"
            type="datetime"
            format="yyyy-MM-dd, HH:mm"
            class="d-inline-block box-datetime"
            :class="{'read-only' : isStartShare, 'blue--text text--accent-4': !isStartShare}"
          >
            <label for="startDate" slot="before">Từ:</label>
          </datetime>
          <datetime
            v-model="toDate"
            input-id="toDate"
            type="datetime"
            format="yyyy-MM-dd, HH:mm"
            class="d-inline-block box-datetime"
            :class="{'read-only' : isStartShare, 'blue--text text--accent-4': !isStartShare}"
          >
            <label for="toDate" slot="before">Đến:</label>
          </datetime>
        </div>
      </v-card>
      <v-card-title class="justify-center pb-0">
        <span class="pr-1 title font-weight-medium">Mã:</span>
        <v-form>
          <v-text-field
            v-model="code"
            label=""
            single-line
            class="title font-weight-medium"
            :class="{'read-only' : isStartShare}"
            mask="####################"
            :rules="[validate.required]"
          ></v-text-field>
        </v-form>
      </v-card-title>
      <v-card-text class="pt-1">
       Ghi chú: nhiều tài khoản Motrak dùng chung một mã sẽ nhìn thấy xe của nhau
      </v-card-text>
      <v-card-actions class="px-3 pb-4 justify-center">
         <v-btn
          color="black white--text btn-share"
          text
          @click="stopShareVehicle"
          round
          v-if="isStartShare"
        >
          Dừng chia sẻ
        </v-btn>
        <v-btn
          color="black white--text btn-share"
          text
          @click="handleShareVehicle"
          round
          v-else
        >
          Bắt đầu chia sẻ
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="dialogNotify"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="headline">Thông báo</v-card-title>

        <v-card-text class="py-0">
          Lộ trình của xe 59F1-12345 đã được chia sẻ.
          Chép đường dẫn sau để gửi đến bạn bè, người thân của bạn:
          <a :href="url" class="blue--text" target="_blank">{{url}}</a>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat="flat"
            @click="dialogNotify = false"
          >
            Đồng ý
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogExist"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="headline">Thông báo</v-card-title>

        <v-card-text class="py-0">
          Mã chia sẻ đã tồn tại, bạn có muốn chia sẻ lộ trình qua mã này
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat="flat"
            @click="dialogExist = false"
          >
            Hủy
          </v-btn>
          <v-btn
            color="primary"
            flat="flat"
            @click="confirmShareVehicle"
          >
            Đồng ý
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { Datetime } from 'vue-datetime';
import moment, { relativeTimeRounding } from 'moment';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as DateTimeUtil from '@/utils/datetime';
import validate from '@/utils/validate';

export default {
  components: {
    Datetime
  },
  data: () => ({
    dialog: false,
    dialogNotify: false,
    fromDate: moment().format(),
    toDate: moment().add(3, 'hours').format(),
    time: '',
    isStartShare: false,
    interval: null,
    code: '',
    validate: validate,
    url: '',
    vehicle: null,
    dialogExist: false,
    isAgreeCode: false
  }),
  computed: {
    ...mapGetters(['selectedVehicle', 'loggedUser'])
  },
  watch: {
    fromDate () {
      this.calculateTime();
    },
    toDate () {
      this.calculateTime();
    }
  },
  mounted () {
    if (this.isStartShare) console.log('test');
  },
  created () {
    this.code = this.loggedUser.phone;
    this.reset();
  },
  methods: {
    ...mapActions(['shareLocation', 'stopSharingLocation', 'getVehicleWaypoints', 'checkSharingCode']),
    open () {
      this.vehicle = this.selectedVehicle.waypoint;
      if (!this.vehicle.sharing.isSharing) {
        this.reset();
      }
      else {
        this.isStartShare = this.vehicle.sharing.isSharing;
        this.fromDate = DateTimeUtil.convertSecond2010ToDateTime(this.vehicle.sharing.startTime).format();
        this.toDate = DateTimeUtil.convertSecond2010ToDateTime(this.vehicle.sharing.endTime).format();
        this.code = this.vehicle.sharing.code;
        this.countDownTime();
      }
      this.dialog = true;
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.reset();
      }, 500);
      
    },

    async handleShareVehicle () {
      let res = await this.checkSharingCode({ code: this.code }).then((data) => {
        return data;
      }).catch(() => {
        return false;
      });
      if (!res) {
        this.startShareVehicle();
        return;
      }
      this.dialogExist = res;
    },
    confirmShareVehicle () {
      this.startShareVehicle();
      this.dialogExist = false;
    },
    async startShareVehicle () {
      if (moment(this.fromDate) > moment(this.toDate) || moment(this.toDate) < moment()) {
        window.getApp.showMessage('Ngày chia sẻ lộ trình không đúng', 'error');
        return;
      }
      if (!this.code) {
        return;
      }
     
      let params = {
        startTime: DateTimeUtil.convertDateTimeToSecond2010(moment(this.fromDate).seconds(0)),
        endTime: DateTimeUtil.convertDateTimeToSecond2010(moment(this.toDate).seconds(0)),
        vehicleIds: [this.vehicle.vehicleId],
        code: this.code
      };
      let res = await this.shareLocation(params).catch(() => {
        return false;
      });
      if (!res || !res.url) {
        window.getApp.showMessage('Có lỗi xảy ra, vui lòng thử lại', 'error');
        return;
      }
      this.url = res.url;
      this.dialogNotify = true;
      this.isStartShare = true;
      await this.getVehicleWaypoints().then((data) => {
        let selected = data.find(item => item.vehicleId === this.selectedVehicle.id);
        if (selected) {
          this.vehicle = selected;
          this.countDownTime();
        }
      });
    },
    async stopShareVehicle () {
      let data = {
        code: this.vehicle.sharing.code,
        vehicleId: this.vehicle.vehicleId
      };
      let res = await this.stopSharingLocation(data).catch(() => {
        return false;
      });
      if (!res) {
        window.getApp.showMessage('Có lỗi xảy ra, vui lòng thử lại', 'error');
        return;
      }
      clearInterval(this.interval);
      this.reset();
    },
    calculateTime () {
      let start = moment(this.fromDate).seconds(0);
      let end = moment(this.toDate).seconds(0);
      let result = 0;
      if (end > start) {
        result = end.diff(start, 'seconds');
      }
      this.time = this.formatTime(result);
    },
    countDownTime () {
      this.interval = setInterval(() => {
        let end = moment(this.toDate).seconds(0);
        let start = moment(this.fromDate).seconds(0);
        let result = '';
        if (start < moment()) { result = end.diff(moment(), 'seconds') }
        else { result = end.diff(start, 'seconds') }
        this.time = this.formatTime(result);
        if (!this.isStartShare || result < 1 || !this.vehicle.sharing.isSharing) {
          clearInterval(this.interval);
          this.reset();
        }
      }, 1000);
    },
    formatTime (value) {
      if (value <= 0) return '00:00:00';
      let hours = Math.floor(moment.duration(value, 'seconds').asHours());
      hours = hours > 9 ? hours : '0' + hours;
      let minutes = moment.duration(value, 'seconds').minutes();
      minutes = minutes > 9 ? minutes : '0' + minutes;
      let seconds = moment.duration(value, 'seconds').seconds();
      seconds = seconds > 9 ? seconds : '0' + seconds;
      return hours + ':' + minutes + ':' + seconds;
    },
    reset () {
      this.code = this.loggedUser.phone;
      this.time = '';
      this.fromDate = moment().format();
      this.toDate = moment().add(3, 'hours').format();
      clearInterval(this.interval);
      this.isStartShare = false;
    }
  }
};
</script>

<style scoped>
.card-dialog{
  position: relative;
}
.box-white{
  border-radius: 10px;
}
.btn-share{
  width: 220px;
}
.btn-close{
  position: absolute !important;
  right: 0;
  top: 0;
}
.read-only{
  pointer-events: none;
}
.box-datetime, .box-datetime>label{
  cursor: pointer !important;
}
</style>
<style>
#fromDate{
  cursor: pointer;
}
#toDate{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/vehicle/components/share.vue